import React, { useState, useEffect } from 'react';
import {
	Box,
	TableContainer,
	Table,
	TableHead,
	TableRow,
	TableCell,
	TableBody,
	TextField,
} from '@mui/material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import SearchIcon from '@mui/icons-material/Search';
import { Link, useLocation } from 'react-router-dom';
import Switch from '@mui/material/Switch';
import Pagination from '@mui/material/Pagination';
import Stack from '@mui/material/Stack';
import { User_Disable, User_Enable, User_Today } from '../../services/Url';
import { Loader } from '../../Components/Loader';
import { enableUSer, post, searchData } from '../../services/Service';
import EditIcon from "@mui/icons-material/Edit";

export default function UserStatList(props) {
	const [data, setData] = useState();
	const [isloading, setIsloading] = useState(true);
	const [searchText, setSearchText] = useState("");
	const [page, setPage] = useState(1);
	let { state } = useLocation();

	let pageData = JSON.stringify({
		"search_string" : searchText,
		"page" : page
	  });

	console.log(props , "Navigate data through router" );
	
	useEffect(() => {
		post(state?.url ,pageData, setData,setIsloading);
	}, []);

	console.log(state?.url ,pageData , "state?.url ,pageData");

	const enableUserHandler = (id) => {
		setIsloading(true);
		setTimeout(() => {
			enableUSer(User_Enable, id, setIsloading);
		}, 1000);
		setTimeout(() => {
			post(state?.url,pageData, setData,setIsloading);
		}, 1500);
	}

	const disableUserHandler = (id) => {
		setIsloading(true);
		setTimeout(() => {
			enableUSer(User_Disable, id, setIsloading);
		}, 1000);
		setTimeout(() => {
			post(state?.url,pageData, setData,setIsloading);
		}, 1500);
	}

	const pagingHandler = (event, value) => {
		setPage(value);
		 let pageData ={
		   "search_string" : searchText,
		   "page" : value
		 }
		 pageData = JSON.stringify(pageData);
		 post(state?.url,pageData, setData,setIsloading);
	 };

	 useEffect(() => {
		searchData(state?.url,pageData , setData);
	}, [searchText]);
	
		const tableData = () => {
			return (
				<TableContainer className='tbl_mn br-24 br-btm-0 '>
					<Box className='table-responsive'>
						<Table className='table-design table_center'>
							<TableHead>
								<TableRow className='tbl_rw'>
									<TableCell className='fz-18 fw-bold'>First Name</TableCell>
									<TableCell className='fz-18 fw-bold'>Last Name</TableCell>
									<TableCell className='fz-18 fw-bold'>Username</TableCell>
									<TableCell className='fz-18 fw-bold'>Email</TableCell>
									<TableCell className='fz-18 fw-bold'>Phone No</TableCell>
									<TableCell className='fz-18 fw-bold'>Address</TableCell>
									<TableCell className='fz-18 fw-bold'>Country</TableCell>
									<TableCell className='fz-18 fw-bold'>Registered Date</TableCell>
									<TableCell className='fz-18 fw-bold'>Block/ Unblock</TableCell>
									<TableCell className='fz-18 fw-bold'>Action</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{data?.docs && data?.docs?.map((item, i) => {
									return (
										<TableRow key={i}>
											<TableCell className='fz-16'>{item.first_name}</TableCell>
											<TableCell className='fz-16'>{item.last_name}</TableCell>
											<TableCell className='fz-16'>{item.username}</TableCell>
											<TableCell className='fz-16'>{item.email}</TableCell>
											<TableCell className='fz-16'>{item.phone_number}</TableCell>
											<TableCell className='fz-16'>{item.address}</TableCell>
											<TableCell className='fz-16'>{item.country}</TableCell>
											<TableCell className='fz-16'>09-08-2022</TableCell>
											<TableCell className='fz-16' style={{ textAlign: "center" }}>
												<Switch
													checked={item.status}
													onChange={() => item.status ? disableUserHandler(item?._id) : enableUserHandler(item?._id)}
													inputProps={{ 'aria-label': 'controlled' }}
												/>
											</TableCell>
											<TableCell className='fz-16'>
											<Link to={`/edituser/${item._id}`} style={{marginRight: "8px"}}><EditIcon /></Link>
												<Link to={`/userdetail/${item._id}`}><RemoveRedEyeIcon /></Link>
											</TableCell>
										</TableRow>
									)
								})
								}

							</TableBody>
						</Table>
					</Box>
					<Box style={{ display: "flex", justifyContent: "center", marginTop: "30px" }}>
						<Stack spacing={2}>
							<Pagination count={data?.totalPages} onChange={pagingHandler} />
						</Stack>
					</Box>
				</TableContainer>
			);
		};

		return (
			<Box display='flex' className='box-wrapper br-24 table_bx' flexDirection='column' justifyContent='start'>
				{isloading ?
					<Loader />
					: ""
				}
				<div className='heading-btn_wrapper'>
					<h5 className='fz-20 fw-bold'>Users Management</h5>
					<Box className='table_srch mb-4'>
						<TextField
							placeholder='Search User By First Name, Last Name, User Name and Email'
							InputProps={{
								startAdornment: <SearchIcon />
							}}
							onChange={(e) => setSearchText(e.target.value)}
						/>
					</Box>
				</div>
				{tableData()}

			</Box>
		);
	}
